import { cva } from 'class-variance-authority';

export const breadcrumbsWrapper = cva(['flex', 'items-center', 'flex-row', 'gap-1']);

export const breadcrumbsItem = cva(['flex', 'items-center', 'flex-row', 'gap-1']);

export const breadcrumbsLink = cva('text-button-regular', {
  variants: {
    isLast: {
      true: ['cursor-default text-[#121212]'],
      false: ['cursor-pointer text-neutral-700'],
    },
  },
});
